export enum CraftingJob {
  ANY = -1,
  CRP = 0,
  BSM = 1,
  ARM = 2,
  GSM = 3,
  LTW = 4,
  WVR = 5,
  ALC = 6,
  CUL = 7,
}
